import { ReactNode, createContext } from 'react';
import { ContactSearchByNumber } from '../../../../../../services/api-client/contact-api';
import {
  EventInboxCommunicationsWidget,
  EventPatientProfile,
  EventPatientProfileWithPhoneNumber
} from '../../../../../../types/event-bus';
import { WidgetRoutePath } from '../../navigation/route-config';

export interface BreadcrumbExtensionProps {
  placeholers?: {
    left?: {
      component: ReactNode;
    };
    right?: {
      component: ReactNode;
    };
  };
}

export interface PatientProfileWidgetContextProps {
  patientIdEvent?: EventPatientProfile | undefined;
  patientPhoneEvent?: EventPatientProfileWithPhoneNumber | undefined;
  patientInboxEvent?: EventInboxCommunicationsWidget | undefined;
  route: WidgetRoutePath | undefined;
  goTo: (route: WidgetRoutePath, skipEventBus?: boolean) => void;
  isLoading: boolean;
  isSkinnyProfile: boolean;
  breadcrumbExtensions: BreadcrumbExtensionProps | undefined;
  setBreadcrumbExtensions: (extensions?: BreadcrumbExtensionProps) => void;
  contactsByPhone: ContactSearchByNumber[];
}

export const PatientProfileWidgetContext = createContext<PatientProfileWidgetContextProps>(null!);
